import { z } from 'zod';
import { DB_TYPE } from '@/common/define/common.define';
import { nullishAsUndefined, nullishToEmpty } from './utils';

export const brokerDetailSchema = z
  .object({
    instanceId: z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
    brokerId: nullishAsUndefined(z.string().optional()),
    brokerName: nullishAsUndefined(z.string().optional()),
    fromTime: nullishAsUndefined(z.string().optional()),
    toTime: nullishAsUndefined(z.string().optional()),
  })
  .transform(({ brokerId, brokerName, ...rest }) => {
    if (rest.instanceId.includes('|')) {
      const [parsedInstanceId, parsedBrokerName] = rest.instanceId.split('|');
      return {
        ...rest,
        instanceId: parsedInstanceId,
        brokerId: brokerId ?? brokerName ?? parsedBrokerName,
      };
    }
    return {
      ...rest,
      brokerId: brokerId ?? brokerName,
    };
  });

export const documentTextSchema = z.object({
  sqlId: z.preprocess(nullishToEmpty(''), z.string({ required_error: 'SQL ID' }).min(1, 'SQL ID')),
  instanceId: z.preprocess(
    nullishToEmpty(''),
    z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
  ),
});

export type BrokerDetailSchema = z.infer<typeof brokerDetailSchema>;
export type DocumentTextSchema = z.infer<typeof documentTextSchema>;

export type BrokerDetailAddition = Omit<BrokerDetailSchema, 'brokerId' | 'brokerName'> & {
  dbType: typeof DB_TYPE.CUBRID;
};
